import React from "react";
import { func } from "prop-types";
import { PROPRIETARY_RESEARCH } from "../partnered-data";
import "./proprietary-research-section.m.css";

export const ProprietaryResearchSection = ({ onPartnerFormOpen }) => {
  return (
    <section id="proprietary-research" styleName="research-detail-section">
      <div styleName="centered">
        <div styleName="content-container">
          <p styleName="research-eyebrow">{PROPRIETARY_RESEARCH.eyebrow}</p>
          <h2 styleName="research-headline">{PROPRIETARY_RESEARCH.headline}</h2>
          <div styleName="research-separator" />
          <div styleName="research-points">
            {PROPRIETARY_RESEARCH.points.map(({ strong, text }) => (
              <p key={`${strong}-${text}`} styleName="research-point">
                <strong>{strong}</strong> {text}
              </p>
            ))}
          </div>
          <button
            styleName="research-button"
            onClick={() => onPartnerFormOpen("Request custom research")}
          >
            {PROPRIETARY_RESEARCH.cta}
          </button>
        </div>
      </div>
    </section>
  );
};

ProprietaryResearchSection.propTypes = {
  onPartnerFormOpen: func.isRequired,
};
